import axios from "axios";

import { getCachedToken, getToken } from "./_tokenRefresh";
import { getResourceTokenIfAvailable } from "./resourceToken";

export type InsightsAuthCredential =
  | { method: "better-auth"; token: string }
  | { method: "legacy"; token: string };

let legacyPageToken: string | undefined;
let legacyCredentialPromise:
  Promise<InsightsAuthCredential | undefined> | undefined;

export const clearInsightsAuthCredential = (): void => {
  legacyCredentialPromise = undefined;
  legacyPageToken = undefined;
};

export const getInsightsAuthCredential = async (
  force = false
): Promise<InsightsAuthCredential | undefined> => {
  const resourceToken = await getResourceTokenIfAvailable("insights", force);
  if (resourceToken) {
    return { method: "better-auth", token: resourceToken };
  }

  const pageToken = await getToken();
  if (!pageToken) throw new Error("No Sked API token found");
  if (pageToken !== legacyPageToken) clearInsightsAuthCredential();

  if (!legacyCredentialPromise) {
    legacyPageToken = pageToken;
    legacyCredentialPromise = (async () => {
      const { data } = await axios.get<{ redirectTo?: string }>(
        "/insights-sso"
      );
      if (!data.redirectTo) return undefined;
      const token = new URL(
        data.redirectTo,
        window.location.origin
      ).searchParams.get("token");
      return token ? ({ method: "legacy", token } as const) : undefined;
    })();
  }

  const pending = legacyCredentialPromise;
  try {
    const credential = await pending;
    if (pageToken !== getCachedToken())
      throw new Error("Authentication context changed");
    return credential;
  } catch (error) {
    if (legacyCredentialPromise === pending) clearInsightsAuthCredential();
    throw error;
  }
};
